import { render, staticRenderFns } from "./StockItem.vue?vue&type=template&id=026aad8a&"
import script from "./StockItem.vue?vue&type=script&lang=js&"
export * from "./StockItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports